module.exports = __webpack_public_path__ + "img/game_pc_yn.14328d45.png";